import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1b289772&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=1b289772&prod&lang=scss"
import style1 from "./Register.vue?vue&type=style&index=1&id=1b289772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b289772",
  null
  
)

export default component.exports